import React, { useCallback, useState, useRef } from 'react'

import './index.scss'
import { Item } from './item'
import * as Storage from '../../utils/storage'
import { useEffect } from 'react'

export const Gnb = ({
  motionState,
  setMotionState,
  setGnbState,
  selectCategory,
}) => {
  const categories = Storage.getCategoryList()

  const category = Storage.getCategory(category)

  const boxRef = useRef(null)
  const onClickMenu = menu => {
    selectCategory(menu)
    closeComponent()
  }
  const closeComponent = () => {
    setMotionState(false)
    setTimeout(() => {
      setGnbState('close')
    }, 500)
  }

  useEffect(() => {
    let timer
    if (motionState) {
      timer = setTimeout(() => {
        boxRef.current.classList.add('active')
      }, 1)
    } else {
      boxRef.current.classList.remove('active')
    }
    return () => clearTimeout(timer)
  }, [motionState])

  return (
    <div className="gnb-wrapper" ref={boxRef}>
      <ul className="gnb">
        <Item title={'All'} category={category} selectCategory={onClickMenu} />
        {categories.map((item, idx) => (
          <Item
            key={idx}
            title={item}
            category={category}
            selectCategory={onClickMenu}
          />
        ))}
      </ul>
    </div>
  )
}
